/**
 * KAN-997: пометка "Был под флудом" (история флуда аккаунта) и фильтр пула
 * по здоровью. Общее для кабинета (TelegramAccount) и раздела "Платформа" (TgPoolAccount).
 */

/** Поля истории флуда, которые отдают оба API. */
export interface FloodMarkFields {
  flood_flagged?: boolean;
  flood_first_at?: string | null;
  flood_last_at?: string | null;
  flood_episodes?: number;
  healthy?: boolean;
}

export const FLOOD_BADGE_TEXT = 'Был под флудом';

/** ISO-время в "дд.мм.гггг" или "-". */
export function formatFloodDate(value: string | null | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/** Подсказка бейджа: "первый: дд.мм.гггг, последний: дд.мм.гггг, эпизодов: N". */
export function floodBadgeTitle(account: FloodMarkFields): string {
  return [
    `первый: ${formatFloodDate(account.flood_first_at)}`,
    `последний: ${formatFloodDate(account.flood_last_at)}`,
    `эпизодов: ${account.flood_episodes ?? 0}`,
  ].join(', ');
}

export type HealthFilter = 'all' | 'healthy' | 'flooded';

export const HEALTH_FILTERS: ReadonlyArray<{ value: HealthFilter; label: string }> = [
  { value: 'all', label: 'Все' },
  { value: 'healthy', label: 'Здоровые' },
  { value: 'flooded', label: 'Были под флудом' },
];

export function isHealthFilter(value: unknown): value is HealthFilter {
  return HEALTH_FILTERS.some((f) => f.value === value);
}

/** Фильтр по здоровью: healthy === true или flood_flagged; вход не мутируется. */
export function filterByHealth<T extends FloodMarkFields>(accounts: T[], filter: HealthFilter): T[] {
  if (filter === 'healthy') return accounts.filter((a) => a.healthy === true);
  if (filter === 'flooded') return accounts.filter((a) => a.flood_flagged === true);
  return accounts;
}

/** Итог снятия пометки: сколько снято, иначе первая ошибка. */
export function clearFloodOutcome(
  results: ReadonlyArray<{ status: string; error: string }>
): { ok: boolean; text: string } {
  const cleared = results.filter((r) => r.status === 'cleared').length;
  if (cleared > 0) return { ok: true, text: `Пометка снята: ${cleared}` };
  const first = results[0];
  return { ok: false, text: first?.error || `Пометка не снята (${first?.status ?? 'нет ответа'})` };
}
